var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initProduct = /* @__PURE__ */ __name(($el, $refs, productHandle) => {
  let scrollContainer = $refs.scrollContainer;
  let gallery = $refs.gallery;
  let init = true;
  if (!scrollContainer) {
    scrollContainer = $el.querySelector(`[x-ref="scrollContainer"]`);
  }
  if (!gallery) {
    gallery = $el.querySelector(`[x-ref="gallery"]`);
  }
  const isPrimary = /^product\.?/gi.test(_stores?.router?.template) && document.querySelector(`[data-section-type="product"]`) === $el;
  const quickView = $el.hasAttribute("data-quick-view");
  const settings = utils.JSONParse($el.getAttribute("data-settings"));
  const columnElements = [gallery, $refs?.content, $refs?.thumbnails].filter(Boolean);
  const scroll_column_element = columnElements?.reduce(
    (acc, element) => acc?.scrollHeight > element?.scrollHeight ? acc : element,
    null
  );
  scroll_column_element?.classList?.remove("sticky-product-section");
  scroll_column_element?.classList?.add("relative");
  const product = utils.JSONParse(
    document.querySelector(`[data-primary-product-data="${productHandle}"]`)?.innerHTML ?? document.querySelector(`[data-product-data="${productHandle}"]`)?.innerHTML
  );
  if (isPrimary) {
    const url = new URL(window.location.href);
    const variantId = url.searchParams.get("variant");
    product.selected_variant_id = variantId ? +variantId : product.selected_variant_id;
  }
  const selected_variant = product?.variants?.find((v) => v.id === product.selected_variant_id);
  const selling_plan_allocations = selected_variant?.selling_plan_allocations;
  const selected_selling_plan = selling_plan_allocations?.[0]?.selling_plan;
  const selling_plan_discount_wording = +selected_selling_plan?.price_adjustments?.[0]?.value ? selected_selling_plan?.price_adjustments?.[0]?.value_type === "fixed_amount" ? `${utils.formatMoney(selected_selling_plan?.price_adjustments?.[0]?.value)} off` : selected_selling_plan?.price_adjustments?.[0]?.value_type === "percentage" ? `Save ${selected_selling_plan?.price_adjustments?.[0]?.value}%` : "" : "";
  const gallerySettings = utils.JSONParse(
    gallery?.getAttribute("data-settings")
  );
  const thumbnailSettings = utils.JSONParse(
    $refs.thumbnails?.getAttribute("data-settings")
  );
  let mediaElements = [
    ...gallery?.querySelectorAll("[data-main-product-images] [data-media-id]") ?? []
  ].map((element) => ({
    element,
    mediaId: +element.getAttribute("data-media-id"),
    metafield: element.hasAttribute("data-metafield-media"),
    media: product?.media?.find((media) => media.id === +element.getAttribute("data-media-id")) ?? product?.variants?.find(
      (v) => v.metafields?.smart?.images?.some(
        (image) => image.id === +element.getAttribute("data-media-id")
      )
    )?.metafields?.smart?.images?.find(
      (image) => image.id === +element.getAttribute("data-media-id")
    )
  }));
  let thumbnailMediaElements = [
    ...$refs.thumbnails?.querySelectorAll("[data-media-id]") ?? []
  ].map((element) => ({
    element,
    mediaId: +element.getAttribute("data-media-id"),
    metafield: element.hasAttribute("data-metafield-media"),
    media: product?.media?.find((media) => media.id === +element.getAttribute("data-media-id")) ?? product?.variants?.find(
      (v) => v.metafields?.smart?.images?.some(
        (image) => image.id === +element.getAttribute("data-media-id")
      )
    )?.metafields?.smart?.images?.find(
      (image) => image.id === +element.getAttribute("data-media-id")
    )
  }));
  // product.price_min/product.price can be corrupted to 0 by unavailable
  // placeholder variants that were never priced (seen on bundle-tier
  // sibling products, e.g. Versatility 3-Pack) - Shopify's own
  // selected_or_first_available_variant_id correctly skips those, and
  // matches the same variant the bundle card's own price comes from.
  const first_available_variant = product?.variants?.find(
    (v) => v.id === product?.selected_or_first_available_variant_id
  );
  let discounted_price = selected_variant?.price ?? first_available_variant?.price ?? product?.price_min ?? product?.price;
  const price_adjustment = selected_selling_plan?.price_adjustments?.[0] ?? selected_variant?.selling_plan_allocations?.[0]?.selling_plan?.price_adjustments?.[0];
  if (price_adjustment?.value_type === "fixed_amount") {
    discounted_price = Math.max(discounted_price - Math.round(+price_adjustment?.value), 0);
  }
  if (price_adjustment?.value_type === "percentage") {
    discounted_price = Math.max(
      discounted_price - Math.round(+price_adjustment?.value / 100 * discounted_price),
      0
    );
  }
  const state = window.Alpine.reactive({
    element: $el,
    count: 0,
    isPrimary,
    product,
    selected_media_id: product?.media?.[0]?.id,
    scroll_column_element,
    show_complementary_products: true,
    properties: {},
    selected_variant,
    selling_plan_allocations,
    selected_price: discounted_price,
    // Before a variant is selected, compare_at_price must fall back to the
    // product-level compare_at_price_min (mirroring the price_min fallback
    // above), not to discounted_price - falling back to discounted_price
    // makes the "compare at" equal the price itself, silently hiding a
    // genuine storefront-wide discount (e.g. Cabos) in the neutral state.
    selected_compare_at_price: Math.max(
      selected_variant?.compare_at_price ?? first_available_variant?.compare_at_price ?? product?.compare_at_price_min ?? discounted_price ?? 0,
      selected_variant?.price ?? first_available_variant?.price ?? discounted_price ?? 0
    ),
    selected_selling_plan: null,
    selling_plan_discount_wording: "",
    isAdding: false,
    dynamic_buy_button: null,
    options: selected_variant?.options ?? new Array(product?.options_with_values?.length || 0).fill(null),
    quantity: 1,
    sibling_handle: "",
    disable_add_to_cart: /* @__PURE__ */ new Set(),
    required_combine_items: [],
    required_combine_quantity: 0,
    upsell_items: /* @__PURE__ */ new Map()
  });
  const card = window.Alpine.reactive({});
  const bundle = window.Alpine.reactive({});
  const handlePopState = /* @__PURE__ */ __name((e) => {
    const url = new URL(window.location.href);
    const selling_plan_id = +url.searchParams.get("selling_plan");
    const variant_id = +url.searchParams.get("variant");
    if (!variant_id) return;
    if (state.selected_variant?.id !== variant_id) {
      state.selected_variant = state.product?.variants?.find((variant) => variant.id === variant_id) ?? state.selected_variant;
      state.options = state.selected_variant?.options;
    }
    if (selling_plan_id !== state.selected_selling_plan?.id) {
      state.selected_selling_plan = state.selected_variant?.selling_plan_allocations?.find(
        (plan) => plan.selling_plan.id === selling_plan_id
      )?.selling_plan ?? state.selected_selling_plan;
    }
  }, "handlePopState");
  const styleDynamicBuyButton = /* @__PURE__ */ __name((element) => {
    const cssClass = element.getAttribute("data-button-class");
    const previewButton = element.querySelector("[data-pre-styled-button]");
    element.style.setProperty(
      "--shopify-accelerated-checkout-button-block-size",
      getComputedStyle(previewButton)?.height
    );
    element.style.setProperty(
      "--shopify-accelerated-checkout-button-border-radius",
      getComputedStyle(previewButton)?.borderRadius
    );
    previewButton.remove();
  }, "styleDynamicBuyButton");
  const handleAddToCart = /* @__PURE__ */ __name(async (e) => {
    if (state.disable_add_to_cart.size > 0) return;
    e.preventDefault();
    e.stopPropagation();
    const random_id = utils.shortUUID();
    const properties = {};
    if (state.upsell_items.size || state.required_combine_items?.length) {
      properties["_p_id"] = `${random_id}`;
    }
    Object.entries(utils.serializeForm($el.querySelector("form")))?.forEach(([key, value]) => {
      if (key.includes("properties[") && value) {
        properties[key.replace(/^properties\[(.*)]$/gi, "$1")] = value;
      }
    });
    state.isAdding = true;
    const data = await _cart.add({
      items: [
        {
          id: state.selected_variant.id,
          quantity: state.quantity,
          selling_plan: state.selected_selling_plan?.id,
          properties: {
            ...properties,
            ...state.properties
          }
        },
        ...[...state.upsell_items.values()].map((entry) => ({
          quantity: state.quantity,
          ...entry,
          properties: {
            ...entry.properties,
            _p_id_link: `${random_id}`
          }
        })),
        ...state.required_combine_items.reduce((acc, item) => {
          const itemIndex = acc.findIndex((addedItem) => addedItem.id === item.id);
          if (itemIndex !== -1) {
            acc[itemIndex].quantity += state.quantity;
            acc[itemIndex].properties["_p_quantity"] = `${acc[itemIndex].quantity}`;
            return acc;
          }
          acc.push({
            id: item.id,
            quantity: state.quantity,
            selling_plan: state.selected_selling_plan?.id ? item.selling_plan_allocations?.find(
              (plan) => plan.selling_plan?.name === state.selected_selling_plan?.name
            )?.selling_plan?.id : void 0,
            properties: {
              _p_id_link: `${random_id}`
            }
          });
          return acc;
        }, [])
      ]
    });
    state.isAdding = false;
    if (!data.cart_error) {
      _stores.modal.setId("cart-drawer");
      _stores.productDrawer.open = false;
      _stores.quickView.open = false;
    }
  }, "handleAddToCart");
  const handleBackInStockNotification = /* @__PURE__ */ __name(async (e) => {
    if (state?.selected_variant?.available) return;
    e.preventDefault();
    e.stopPropagation();
    _stores.backInStockNotification.open = true;
    _stores.backInStockNotification.product = state.product;
    _stores.backInStockNotification.selected_variant = state.selected_variant;
  }, "handleBackInStockNotification");
  // handleBackInStockNotification's own availability guard would no-op here,
  // since this helper must open the modal even when the selected variant IS
  // available (customer is asking about a different, unavailable size). It
  // must also open with no PDP size chosen yet - state.selected_variant is
  // undefined in that case, but the modal's own "Choose an option" dropdown
  // (confirmed live: lists every variant and updates its own selection via
  // setSelectedVariant) prompts the customer for a size itself, so passing
  // undefined through is safe and never subscribes an arbitrary variant.
  const handleBackInStockHelperClick = /* @__PURE__ */ __name((e) => {
    e.preventDefault();
    e.stopPropagation();
    _stores.backInStockNotification.open = true;
    _stores.backInStockNotification.product = state.product;
    _stores.backInStockNotification.selected_variant = state.selected_variant;
  }, "handleBackInStockHelperClick");
  const setSelectedVariant = /* @__PURE__ */ __name((id, scroll_to_variant = true) => {
    state.selected_variant = state.product.variants?.find((variant) => variant.id === id);
    state.options = state.selected_variant?.options;
    if (state.selected_selling_plan && !state.selected_variant?.selling_plan_allocations?.some(
      (plan) => plan?.selling_plan?.id === state.selected_selling_plan?.id
    )) {
      state.selected_selling_plan = state.selected_variant?.selling_plan_allocations?.[0]?.selling_plan ?? null;
    }
    if (state.product.requires_selling_plan && !state.selected_selling_plan) {
      state.selected_variant?.selling_plan_allocations?.[0]?.selling_plan ?? state.product.selling_plan_groups?.[0]?.selling_plans?.[0];
    }
    if (gallerySettings?.scroll_to_selected_variant_image && state.selected_variant?.featured_media?.id && scroll_to_variant) {
      scrollToMediaById(state.selected_variant?.featured_media?.id, false);
    }
    _product.lastOptions = {
      ..._product.lastOptions ?? {},
      ...state.product.options_with_values?.reduce((acc, option, index) => {
        acc[utils.handlelize(option?.name)] = state.options[index];
        return acc;
      }, {}) ?? {}
    };
  }, "setSelectedVariant");
  const toggleSelectedVariant = /* @__PURE__ */ __name((id, scroll_to_variant = true) => {
    if (state.selected_variant?.id === id) {
      state.selected_variant = void 0;
      state.options = new Array(state.product?.options_with_values?.length || 0).fill(null);
      return;
    }
    setSelectedVariant(id, scroll_to_variant);
  }, "toggleSelectedVariant");
  const setProductOption = /* @__PURE__ */ __name(({ index, value }) => {
    const options = [...state.options];
    options[index] = value;
    if (options.some((option) => option == null)) {
      state.options = options;
      state.selected_variant = void 0;
      return;
    }
    const match = state.product?.variants?.find(
      (variant) => variant.options.every((option, i) => options[i] === option)
    );
    if (match) {
      setSelectedVariant(match.id);
      return;
    }
    state.options = options.map((option, i) => i === index ? option : null);
    state.selected_variant = void 0;
  }, "setProductOption");
  const toggleProductOption = /* @__PURE__ */ __name(({ index, value }) => {
    setProductOption({ index, value: state.options?.[index] === value ? null : value });
  }, "toggleProductOption");
  const setSellingPlan = /* @__PURE__ */ __name((selling_plan_id) => {
    state.selected_selling_plan = state.selling_plan_allocations.find(
      (allocation) => allocation.selling_plan.id === selling_plan_id
    )?.selling_plan;
    const selling_plan = state.selected_selling_plan ?? selling_plan_allocations?.[0]?.selling_plan;
    state.selling_plan_discount_wording = selling_plan?.price_adjustments?.[0]?.value ? selling_plan?.price_adjustments?.[0]?.value_type === "fixed_amount" ? `${utils.formatMoney(selling_plan?.price_adjustments?.[0]?.value)} off` : selling_plan?.price_adjustments?.[0]?.value_type === "percentage" ? `Save ${selling_plan?.price_adjustments?.[0]?.value}%` : "" : "";
  }, "setSellingPlan");
  // Lightweight, non-Barba sibling swap (Color / Fit). Mirrors birddogs.com's
  // interaction model: only the currently-viewed product is loaded initially;
  // clicking a sibling fetches that ONE product's data on demand via
  // _product.getHydratedSiblingData (DOM -> IndexedDB -> a `limit=1`
  // /recommendations/products fetch, ~40-45KB vs. the ~210KB the shared
  // limit=10 getFetchProduct pulls for cart/quickview use) and patches the
  // page in place - no full Barba document navigation, so scroll position is
  // never touched. Falls back to the original barba.go() full navigation
  // whenever the lightweight path can't safely represent the result (missing
  // data, non-image media the client-side gallery rebuild doesn't support,
  // or any error applying the swap), so the customer is never left stuck on
  // a half-updated page.
  //
  // Back/Forward across a Color/Fit change is deliberately left to Barba's
  // OWN existing full-page transition rather than intercepted here: Barba's
  // popstate handler (assets/barba.umd.js) always compares the browser's
  // current URL against its own internally-tracked "current" history entry
  // and forces a real leave/enter transition whenever they differ -
  // regardless of whether that URL got there via barba.go, a raw
  // history.pushState, or barba.history.add. A raw pushState call was
  // confirmed live to desync Barba's internal index (reproduced as a
  // corrupted $0 price after back()), because Barba's own history.change()
  // only reconciles correctly when it recognizes its OWN {from,index,states}
  // shape on event.state. Routing the URL update through barba.history.add
  // below keeps that bookkeeping consistent, so Back/Forward onto a
  // different product correctly falls through to Barba's already-correct,
  // already-shipped full transition instead of a broken hybrid state.
  let swapGeneration = 0;
  // Templates Mugsy already maintains as a matched set for PDP behavior -
  // same grouping the ATC subtext logic (product.add_to_cart_button.liquid)
  // and the reassurance-icon fix use. Verified live (Willys vs. Squid Inks)
  // that blank/"" and "product-bundle-new" share the same block-type set,
  // gallery structure, and Okendo widget markup, so a sibling swap between
  // them is safe. non-clothing-product/product-twill-drawstring are grouped
  // in on the strength of that same existing codebase pattern, not a direct
  // live comparison - if either turns out incompatible for some product,
  // the try/catch around applySiblingProduct() still falls back safely to a
  // full navigation rather than showing a broken page.
  const COMPATIBLE_TEMPLATE_FAMILY = /* @__PURE__ */ new Set(["", "product-bundle-new", "non-clothing-product", "product-twill-drawstring"]);
  // Fit siblings turned out to be asymmetric in the underlying catalog data
  // (product.metafields.smart.sibling_products, confirmed as the exact
  // metafield product.sibling__radio.liquid's Fit block reads from theme
  // block settings): Squid Inks (the "anchor") lists all 3 fits, but a
  // color sibling like Mags or Willys only lists ITSELF. That's why the Fit
  // fieldset carried Squid Inks' 3-button shell into every swap regardless
  // of whether the now-viewed product actually has those other fits - it
  // was never re-derived from the viewed product's own data at all, same
  // class of gap as the title bug but for the swatch SET, not just its
  // active state/label. The fix rebuilds the Fit fieldset's actual <label>
  // set from state.product.metafields.smart.sibling_products on every swap,
  // so it always matches the currently-viewed product's own real fit
  // options - collapsing to 1 for Mags/Willys, expanding back to 3 when a
  // swap lands back on an anchor-style product. The Fit fieldset itself is
  // identified once here by matching its server-rendered data-values against
  // the initial page's own sibling_products handles (data-driven, not a
  // guess from swatch count or keywords), so this adapts if a merchant ever
  // repoints which block reads which metafield.
  const initialFitHandles = (product?.metafields?.smart?.sibling_products ?? []).map((entry) => entry?.product).filter(Boolean);
  const fitFieldsetEl = initialFitHandles.length ? [...$el.querySelectorAll("fieldset[data-values]")].find((fieldsetEl) => {
    let vals;
    try {
      vals = utils.JSONParse(fieldsetEl.getAttribute("data-values")) ?? [];
    } catch (e) {
      return false;
    }
    return vals.length === initialFitHandles.length && initialFitHandles.every((h, i) => h === vals[i]);
  }) : null;
  // Bundle-tier (pack count) fieldset, identified by its unique DOM wrapper
  // rather than by matching metafield data - product.sibling__radio.liquid's
  // bundle-card branch is the only one that renders a
  // <details class="pdp-bundle-disclosure">, so this is a reliable,
  // data-independent signal. Bundle-tier switching itself still always
  // forces a full navigation (setSiblingProduct's forceFullNav path), so the
  // only thing that needs to track the currently-viewed product here is the
  // collapsed summary (title + whether the row shows at all) - the same
  // proportionate scope as the title fix, not a full rebuild of the
  // expanded pack cards' pricing, which is constant per bundle-tier product
  // regardless of which color you started from.
  const bundleDetailsEl = $el.querySelector(".pdp-bundle-disclosure");
  const bundleFieldsetEl = bundleDetailsEl?.querySelector("fieldset[data-values]") ?? null;
  // Seeded from every fieldset's own data-product-ids at mount, then grown
  // with every product successfully fetched during this session - lets a
  // rebuilt Fit swatch resolve a real productId (needed for the lightweight
  // fetch's network tier) for handles this page already knows about, even
  // though sibling_products itself only gives handles, not ids. A handle
  // this map has no id for still works: it just falls through to a real
  // navigation when clicked, the same safe fallback used everywhere else.
  const knownProductIds = {};
  $el.querySelectorAll("fieldset[data-values][data-product-ids]").forEach((fieldsetEl) => {
    try {
      const handles = utils.JSONParse(fieldsetEl.getAttribute("data-values")) ?? [];
      const ids = utils.JSONParse(fieldsetEl.getAttribute("data-product-ids")) ?? [];
      handles.forEach((h, i) => {
        if (h && ids[i]) knownProductIds[h] = ids[i];
      });
    } catch (e) {
    }
  });
  if (product?.id && product?.handle) {
    knownProductIds[product.handle] = product.id;
  }
  const IMAGE_SRCSET_BREAKPOINTS = [48, 96, 256, 384, 460, 640, 1200, 1920, 3840];
  const cdnImageUrl = /* @__PURE__ */ __name((src, width) => {
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set("width", `${width}`);
      return url.toString();
    } catch (e) {
      return src;
    }
  }, "cdnImageUrl");
  const buildImageSrcset = /* @__PURE__ */ __name((src, maxWidth) => {
    return IMAGE_SRCSET_BREAKPOINTS.filter((w) => w <= maxWidth).map((w) => `${cdnImageUrl(src, w)} ${w}w`).join(", ");
  }, "buildImageSrcset");
  const parseGalleryAspect = /* @__PURE__ */ __name((raw) => {
    const parts = (raw || "").replace(/\s/g, "").split("|");
    const aspect = (parts[1] || "").split("/");
    return { aspectDesktop: aspect[0], aspectMobile: aspect[1] };
  }, "parseGalleryAspect");
  const buildGalleryPicture = /* @__PURE__ */ __name((media, index, aspect) => {
    const picture = document.createElement("picture");
    picture.setAttribute("data-media-id", `${media.id}`);
    picture.setAttribute("data-style-media-item", "");
    picture.setAttribute("tabindex", "-1");
    picture.className = "snap-start relative flex aspect-[--aspect-ratio] w-full shrink-0 overflow-hidden lg:aspect-[--aspect-ratio-md] h-full";
    let style = "";
    if (aspect.aspectDesktop === "auto") style += `--aspect-ratio-md: ${media.preview_image?.aspect_ratio};`;
    if (aspect.aspectMobile === "auto") style += `--aspect-ratio: ${media.preview_image?.aspect_ratio};`;
    picture.setAttribute("style", style);
    if (gallerySettings?.hide_image_alt && media.alt === gallerySettings.hide_image_alt) {
      picture.classList.add("!hidden");
    }
    if (gallerySettings?.additional_view === "media_gallery") {
      picture.classList.add("cursor-zoom-in");
      picture.addEventListener("click", () => openMediaGallery(media.id));
    }
    const img = document.createElement("img");
    const src = media.preview_image?.src;
    const maxWidth = media.preview_image?.width || 1920;
    img.src = cdnImageUrl(src, Math.min(maxWidth, 1200));
    img.srcset = buildImageSrcset(src, maxWidth);
    img.sizes = "(max-width: 768px) 95vw, (max-width: 1024px) 50vw, 40vw";
    img.alt = media.alt || "";
    img.loading = index === 0 ? "eager" : "lazy";
    img.className = "w-full h-full object-cover select-none";
    picture.appendChild(img);
    return picture;
  }, "buildGalleryPicture");
  const buildThumbnailButton = /* @__PURE__ */ __name((media, index) => {
    const button = document.createElement("button");
    button.type = "button";
    button.setAttribute("data-style-thumbnail", "");
    button.setAttribute("data-media-id", `${media.id}`);
    button.setAttribute("tabindex", "-1");
    button.className = "relative flex shrink-0 overflow-hidden";
    button.addEventListener("click", () => scrollToMediaById(media.id));
    const img = document.createElement("img");
    const src = media.preview_image?.src;
    const maxWidth = media.preview_image?.width || 1920;
    img.src = cdnImageUrl(src, Math.min(maxWidth, 384));
    img.srcset = buildImageSrcset(src, maxWidth);
    img.sizes = "(max-width: 768px) 25vw, (max-width: 1024px) 20vw, 15vw";
    img.alt = media.alt || "";
    img.loading = index < 6 ? "eager" : "lazy";
    img.className = "w-full h-full object-[inherit] select-none";
    button.appendChild(img);
    return button;
  }, "buildThumbnailButton");
  const rebuildGalleryDom = /* @__PURE__ */ __name((product2) => {
    const unsupported = product2.media?.some((m) => m.media_type && m.media_type !== "image");
    if (unsupported) {
      throw new Error("sibling swap: unsupported media type, falling back to full navigation");
    }
    if (!scrollContainer) {
      throw new Error("sibling swap: gallery container not found");
    }
    const aspect = parseGalleryAspect(gallerySettings?.image_gap_aspect_ratio);
    scrollContainer.innerHTML = "";
    (product2.media ?? []).forEach((media, index) => {
      scrollContainer.appendChild(buildGalleryPicture(media, index, aspect));
    });
    mediaElements = [...scrollContainer.querySelectorAll("[data-media-id]")].map((element) => ({
      element,
      mediaId: +element.getAttribute("data-media-id"),
      metafield: false,
      media: product2?.media?.find((m) => m.id === +element.getAttribute("data-media-id"))
    }));
    if ($refs.thumbnails) {
      $refs.thumbnails.innerHTML = "";
      (product2.media ?? []).forEach((media, index) => {
        $refs.thumbnails.appendChild(buildThumbnailButton(media, index));
      });
      thumbnailMediaElements = [...$refs.thumbnails.querySelectorAll("[data-media-id]")].map((element) => ({
        element,
        mediaId: +element.getAttribute("data-media-id"),
        metafield: false,
        media: product2?.media?.find((m) => m.id === +element.getAttribute("data-media-id"))
      }));
    }
  }, "rebuildGalleryDom");
  const updateProductTitleAndDescription = /* @__PURE__ */ __name((product2, previousTitle) => {
    // product.title.liquid's own x-html ("$el.getAttribute('data-content')
    // .replace('[title]', $data.state?.product?.title)") turned out to be
    // dead code, not a broken-reactivity bug: data-content already has the
    // CURRENT product's name baked in as literal text, not the literal
    // "[title]" token - _input.richtext resolves that token server-side
    // before the attribute is ever written, so the client-side .replace()
    // never finds a match. Confirmed live that this effect DOES still
    // re-fire on other, unrelated state writes during a swap (state.options,
    // state.selected_variant, etc.) even though title itself didn't change -
    // so patching only .innerHTML got silently reverted back to the stale
    // value the next time some other state write caused Alpine to re-flush
    // it. The data-content ATTRIBUTE itself has to be patched too (same
    // old-title-for-new-title substring swap), since that's what the
    // effect recomputes .innerHTML from on every re-run, however triggered.
    // product.description.liquid has no Alpine binding whatsoever (plain
    // {{ product.description }}), so it never reacted to begin with and
    // needs the same direct-patch treatment, minus this re-fire concern.
    if (previousTitle && product2.title) {
      $el.querySelectorAll('[data-block-type="title"] [data-content]').forEach((el) => {
        if (el.textContent.includes(previousTitle)) {
          el.innerHTML = el.innerHTML.split(previousTitle).join(product2.title);
        }
        const template = el.getAttribute("data-content");
        if (template && template.includes(previousTitle)) {
          el.setAttribute("data-content", template.split(previousTitle).join(product2.title));
        }
      });
    }
    // Only the single-container description styles (plain / accordion_plain)
    // are patched here. accordion_h1 renders one accordion per <h1> heading
    // split out of product.description - replicating that split correctly
    // client-side isn't worth the risk of duplicating/mangling content, so
    // that style (detected by having more than one container) is left as-is
    // rather than guessed at.
    $el.querySelectorAll('[data-block-type="description"]').forEach((block) => {
      const containers = block.querySelectorAll(".prose, .accordion-content");
      if (containers.length === 1) {
        containers[0].innerHTML = product2.description ?? "";
      }
    });
  }, "updateProductTitleAndDescription");
  const updateBreadcrumb = /* @__PURE__ */ __name((product2) => {
    // _blocks.breadcrumbs.liquid always renders the current product's name as
    // the LAST ".truncate.opacity-60" span in the trail (title_2), whether or
    // not a collection crumb precedes it - that span has no Alpine binding of
    // its own, so a direct textContent patch is safe and won't get reverted
    // by an unrelated re-render the way title.liquid's dead effect did.
    const nav = $el.querySelector("[data-breadcrumbs-block]");
    if (!nav || !product2?.title) return;
    const crumbs = nav.querySelectorAll(".truncate.opacity-60");
    const productCrumb = crumbs[crumbs.length - 1];
    if (!productCrumb) return;
    productCrumb.textContent = product2.title;
    if (productCrumb.tagName === "A" && product2.url) {
      productCrumb.setAttribute("href", product2.url);
    }
  }, "updateBreadcrumb");
  const syncSiblingFieldsets = /* @__PURE__ */ __name((newHandle) => {
    $el.querySelectorAll("fieldset[data-values]").forEach((fieldsetEl) => {
      let handles;
      try {
        handles = utils.JSONParse(fieldsetEl.getAttribute("data-values")) ?? [];
      } catch (e) {
        return;
      }
      const idx = handles.indexOf(newHandle);
      const scope = window.Alpine?.$data ? window.Alpine.$data(fieldsetEl) : null;
      if (scope && idx > -1) {
        scope.current_sibling = newHandle;
      }
      if (idx === -1) return;
      fieldsetEl.setAttribute("data-value", newHandle);
      let matchInput;
      try {
        matchInput = fieldsetEl.querySelector(`input[value="${CSS.escape(newHandle)}"]`);
      } catch (e) {
        matchInput = null;
      }
      const label = matchInput?.closest("label");
      // aria-label checked first, not data-tooltip: for product.sibling__color.liquid
      // both hold the same human-readable value (e.g. "Charcoal Seersucker"), but for
      // product.sibling__radio.liquid (Fit) data-tooltip is set to the raw sibling
      // HANDLE (used only for x-effect's active-class matching against
      // current_sibling), while aria-label is the actual human title ("Slim Tapered").
      // Checking data-tooltip first meant the Fit legend showed a product handle
      // after a Fit swap - confirmed live (e.g. "squid-inks-tapered" instead of
      // "Slim Tapered") - since it's never empty so the aria-label fallback never ran.
      const title = matchInput?.getAttribute("aria-label") || label?.getAttribute("data-tooltip") || fieldsetEl.querySelector(`option[value="${newHandle}"]`)?.textContent?.trim() || "";
      const legend = fieldsetEl.querySelector("[data-legend]");
      if (legend && title) {
        legend.setAttribute("data-current-title", title);
        legend.innerHTML = (legend.getAttribute("data-legend") || "").replace("[value]", title);
      }
    });
  }, "syncSiblingFieldsets");
  const rebuildFitFieldset = /* @__PURE__ */ __name((product2) => {
    if (!fitFieldsetEl) return;
    const siblingProducts = product2?.metafields?.smart?.sibling_products;
    // No data at all for this product - rather than fight Alpine's own
    // x-show="showConditionally(...)" on the wrapping block (which can
    // still re-fire from unrelated reactivity and silently undo a manual
    // hide, the same failure mode the title fix had to work around),
    // leave the fieldset showing whatever it last had. A product missing
    // this metafield entirely hasn't been seen in this catalog so far -
    // every product checked has at least itself as a single entry.
    if (!Array.isArray(siblingProducts) || !siblingProducts.length) return;
    const container = fitFieldsetEl.querySelector("[data-style-container]");
    if (!container) return;
    const templateLabel = container.querySelector("label");
    const templateClass = templateLabel ? templateLabel.className.replace(/\bactive\b/, "").trim() : "";
    const radioName = fitFieldsetEl.querySelector('input[type="radio"]')?.name ?? `fit-${product2.id}`;
    const handles = siblingProducts.map((entry) => entry?.product).filter(Boolean);
    const titles = siblingProducts.map((entry) => entry?.title ?? "");
    container.innerHTML = "";
    handles.forEach((handle, i) => {
      const label = document.createElement("label");
      label.className = templateClass;
      label.classList.toggle("active", handle === product2.handle);
      label.setAttribute("data-tooltip", handle);
      const input = document.createElement("input");
      input.type = "radio";
      input.className = "sr-only";
      input.name = radioName;
      input.value = handle;
      input.setAttribute("aria-label", titles[i] || handle);
      input.checked = handle === product2.handle;
      input.addEventListener("change", () => setSiblingProduct(handle, null, fitFieldsetEl));
      const span = document.createElement("span");
      span.setAttribute("aria-hidden", "true");
      span.textContent = titles[i];
      label.appendChild(input);
      label.appendChild(span);
      container.appendChild(label);
    });
    fitFieldsetEl.setAttribute("data-values", JSON.stringify(handles));
    fitFieldsetEl.setAttribute(
      "data-product-ids",
      JSON.stringify(handles.map((h) => knownProductIds[h] ?? null))
    );
    fitFieldsetEl.setAttribute("data-value", product2.handle);
    const scope = window.Alpine?.$data ? window.Alpine.$data(fitFieldsetEl) : null;
    if (scope) {
      scope.current_sibling = product2.handle;
    }
  }, "rebuildFitFieldset");
  // This wrapper (and others like it) has transition: all applied globally
  // in this theme's CSS. display itself never animates, but toggling it can
  // still cause an animated reflow of neighboring block-level margins under
  // that rule in some browsers, which would read as a brief layout jump
  // right after a swap that a hard reload (no transition to run) wouldn't
  // show. Not reproduced in direct frame-by-frame testing here, but
  // disabling transitions on the element being toggled is a safe,
  // no-downside precaution regardless.
  const setDisplayWithoutTransition = /* @__PURE__ */ __name((el, display) => {
    if (!el) return;
    const prevTransition = el.style.transition;
    el.style.transition = "none";
    el.style.display = display;
    void el.offsetHeight;
    el.style.transition = prevTransition;
  }, "setDisplayWithoutTransition");
  const rebuildBundleSummary = /* @__PURE__ */ __name((product2) => {
    if (!bundleFieldsetEl || !bundleDetailsEl) return;
    // Bundle & Save is scoped to product-bundle-new specifically, not the
    // wider COMPATIBLE_TEMPLATE_FAMILY sameTemplate uses for the rest of the
    // swap - confirmed live that a blank/Default product like Rusties can
    // still carry a populated (if vestigial, self-only) smart_bundle_product
    // metafield despite its own template never rendering the block at all,
    // so metafield presence alone isn't a reliable signal here. This is a
    // deliberate, explicit product decision, not an inferred one.
    const bundleData = product2?.template_suffix === "product-bundle-new" ? product2?.metafields?.custom?.smart_bundle_product : null;
    if (!Array.isArray(bundleData) || !bundleData.length) {
      setDisplayWithoutTransition(bundleDetailsEl, "none");
      setDisplayWithoutTransition(bundleDetailsEl.closest("[data-block-type]"), "none");
      return;
    }
    setDisplayWithoutTransition(bundleDetailsEl, "");
    setDisplayWithoutTransition(bundleDetailsEl.closest("[data-block-type]"), "");
    const parseTierTitle = (rawTitle) => {
      const cleanTitle = (rawTitle ?? "").split("(")[0].trim();
      const displayTitle = cleanTitle === "Single" ? "Single Pair" : cleanTitle;
      const savingsMatch = (rawTitle ?? "").match(/\(([^)]*)\)/);
      let badgeText = null;
      if (cleanTitle.includes("2-Pack")) badgeText = "Most Popular";
      else if (cleanTitle.includes("3-Pack")) badgeText = "Best Value";
      return { displayTitle, savingsText: savingsMatch ? savingsMatch[1] : null, badgeText };
    };
    const currentEntry = bundleData.find((e) => e?.product === product2.handle) ?? bundleData[0];
    const current = parseTierTitle(currentEntry?.title);
    const titleEl = bundleDetailsEl.querySelector(".pdp-bundle-disclosure__current-title");
    if (titleEl) titleEl.textContent = current.displayTitle;
    const currentWrap = bundleDetailsEl.querySelector(".pdp-bundle-disclosure__current");
    let savingsEl = bundleDetailsEl.querySelector(".pdp-bundle-disclosure__current-savings");
    if (current.savingsText) {
      if (!savingsEl && currentWrap) {
        savingsEl = document.createElement("span");
        savingsEl.className = "pdp-bundle-disclosure__current-savings";
        currentWrap.appendChild(savingsEl);
      }
      if (savingsEl) savingsEl.textContent = current.savingsText;
    } else if (savingsEl) {
      savingsEl.remove();
    }
    bundleFieldsetEl.setAttribute("data-value", product2.handle);
    const scope = window.Alpine?.$data ? window.Alpine.$data(bundleFieldsetEl) : null;
    if (scope) {
      scope.current_sibling = product2.handle;
    }
    // Remapping the expanded pack cards themselves (not just the collapsed
    // summary above) - the pack-tier relationship turned out to be just as
    // per-product/asymmetric as Fit (Mags' own 2-/3-pack siblings are
    // "weekend-2-pack"/"weekend-3-pack", genuinely different products from
    // Squid Inks' "essentials-2-pack"/"essentials-3-pack"), so leaving the
    // cards frozen from the original page would silently send a customer
    // who expands this after swapping color to the WRONG color's pack
    // product. Only handle/label/badge get remapped here, matched by card
    // position - the $ price/savings figures shown on each card are left
    // as-is (same, deliberately smaller scope as the collapsed summary
    // above): they require that sibling's own variant pricing, which isn't
    // in this lightweight payload, and pack-tier pricing is consistent
    // across colors in this catalog in every case checked so far. If the
    // entry count doesn't match the rendered card count, the whole block is
    // hidden instead of guessing a card-to-entry mapping that could put a
    // wrong handle behind the wrong label.
    const cards = [...bundleFieldsetEl.querySelectorAll(".pdp-bundle-card")];
    if (cards.length !== bundleData.length) {
      setDisplayWithoutTransition(bundleDetailsEl, "none");
      setDisplayWithoutTransition(bundleDetailsEl.closest("[data-block-type]"), "none");
      return;
    }
    const handles = [];
    cards.forEach((card, i) => {
      const entry = bundleData[i];
      const handle = entry?.product;
      handles.push(handle ?? null);
      if (!handle) return;
      const parsed = parseTierTitle(entry.title);
      card.setAttribute("data-tooltip", handle);
      const input = card.querySelector('input[type="radio"]');
      if (input) input.value = handle;
      const titleSpan = card.querySelector(".pdp-bundle-card__title");
      if (titleSpan) titleSpan.textContent = parsed.displayTitle;
      let badge = card.querySelector('[class*="pdp-bundle-card__badge"]');
      if (parsed.badgeText) {
        if (!badge) {
          badge = document.createElement("span");
          card.insertBefore(badge, card.firstChild);
        }
        badge.className = `pdp-bundle-card__badge pdp-bundle-card__badge--${parsed.badgeText === "Most Popular" ? "popular" : "value"}`;
        badge.textContent = parsed.badgeText;
      } else if (badge) {
        badge.remove();
      }
    });
    bundleFieldsetEl.setAttribute("data-values", JSON.stringify(handles));
    bundleFieldsetEl.setAttribute(
      "data-product-ids",
      JSON.stringify(handles.map((h) => h ? knownProductIds[h] ?? null : null))
    );
  }, "rebuildBundleSummary");
  const updateYotpoWidgetsForProduct = /* @__PURE__ */ __name((product2) => {
    const main = document.querySelector(".yotpo.yotpo-main-widget[data-product-id]");
    if (main) {
      main.setAttribute("data-product-id", `${product2.id}`);
      main.setAttribute("data-name", product2.title || "");
      main.setAttribute("data-url", `${window.location.origin}${utils.getSiblingUrl(product2.handle).replace(window.location.origin, "")}`);
      const imageSrc = product2.featured_image?.src ?? product2.media?.[0]?.preview_image?.src;
      main.setAttribute("data-image-url", imageSrc ? cdnImageUrl(imageSrc, 600) : "");
      main.setAttribute("data-price", ((product2.price ?? 0) / 100).toFixed(2));
    }
    document.querySelectorAll(".yotpo.bottomLine[data-product-id]").forEach((el) => {
      el.setAttribute("data-product-id", `${product2.id}`);
    });
    // Live product-bundle-new templates actually render Okendo's review
    // widgets, not the Yotpo markup in sections/yotpo-reviews.liquid -
    // confirmed by inspecting the rendered DOM directly rather than
    // assuming from the Liquid source. There are at least two distinct
    // Okendo widget instances on a PDP - the full list (data-oke-widget,
    // inside #product-reviews) and a separate star-rating summary badge
    // near the title (data-oke-star-rating, a "@app" block) - each with
    // its own data-oke-reviews-product-id. Matching on data-oke-widget
    // alone (as this used to) missed the summary badge entirely, leaving
    // it stuck on the pre-swap product - confirmed live, this is what
    // read as "reviews disappeared/wrong" when watching a swap happen.
    // Matching on data-oke-reviews-product-id alone instead catches every
    // Okendo widget flavor on the page. data-oke-rendered is Okendo's own
    // "already initialized, skip" guard, so it has to be cleared or
    // initAllWidgets() will no-op on a widget it thinks is done.
    document.querySelectorAll("[data-oke-reviews-product-id]").forEach((el) => {
      el.setAttribute("data-oke-reviews-product-id", `shopify-${product2.id}`);
      el.removeAttribute("data-oke-rendered");
    });
    window?.yotpoWidgetsContainer?.initWidgets?.();
    window?.okeWidgetApi?.initAllWidgets?.();
  }, "updateYotpoWidgetsForProduct");
  const publishSiblingAnalytics = /* @__PURE__ */ __name((product2, selectedVariant) => {
    if (window.ShopifyAnalytics?.meta) {
      window.ShopifyAnalytics.meta.product = {
        ...window.ShopifyAnalytics.meta.product ?? {},
        id: product2.id,
        gid: `gid://shopify/Product/${product2.id}`,
        vendor: product2.vendor,
        handle: product2.handle,
        variants: (product2.variants ?? []).map((v) => ({
          id: v.id,
          price: v.price,
          name: `${product2.title} - ${v.title}`,
          public_title: v.title,
          sku: v.sku
        }))
      };
      if (window.ShopifyAnalytics.meta.page) {
        window.ShopifyAnalytics.meta.page.resourceId = product2.id;
      }
      window.ShopifyAnalytics.meta.selectedVariantId = selectedVariant?.id;
    }
    Shopify.analytics?.publish("_page_viewed");
    Shopify.analytics?.publish("_product_viewed");
    document.dispatchEvent(new CustomEvent("pageFullyLoaded", {}));
  }, "publishSiblingAnalytics");
  const resolveSiblingProductId = /* @__PURE__ */ __name((handle, fieldsetEl) => {
    const fieldsets = fieldsetEl ? [fieldsetEl] : [...$el.querySelectorAll("fieldset[data-values]")];
    for (const fs of fieldsets) {
      try {
        const handles = utils.JSONParse(fs.getAttribute("data-values")) ?? [];
        const ids = utils.JSONParse(fs.getAttribute("data-product-ids")) ?? [];
        const idx = handles.indexOf(handle);
        if (idx > -1 && ids[idx]) return ids[idx];
      } catch (e) {
      }
    }
    return knownProductIds[handle] ?? null;
  }, "resolveSiblingProductId");
  const applySiblingProduct = /* @__PURE__ */ __name((product2) => {
    if (product2.id && product2.handle) {
      knownProductIds[product2.handle] = product2.id;
    }
    const previousTitle = state.product?.title;
    rebuildGalleryDom(product2);
    // Matches the existing init/barba_redirect branch of the effect below
    // (no selected_or_first_available_variant_id fallback) so a sibling swap
    // lands unselected exactly like a fresh full-navigation page load does -
    // falling back to first-available here would both wrongly pre-pick a
    // size the customer never chose AND, via the URL-sync effect further
    // down reacting to a non-null state.selected_variant, leak a stray
    // ?variant= param onto the clean sibling URL.
    const resolvedVariant = product2.variants?.find((v) => v.id === product2.selected_variant_id);
    state.product = product2;
    state.selected_variant = resolvedVariant;
    state.selected_media_id = product2.media?.[0]?.id;
    state.properties = {};
    state.selling_plan_allocations = resolvedVariant?.selling_plan_allocations;
    state.selected_selling_plan = null;
    state.selling_plan_discount_wording = "";
    state.dynamic_buy_button = null;
    state.options = resolvedVariant?.options ?? new Array(product2?.options_with_values?.length || 0).fill(null);
    handleImageSelection(gallerySettings?.filter_images, mediaElements, state.selected_variant);
    if (thumbnailSettings) {
      handleImageSelection(
        thumbnailSettings?.thumbnail_filter_images === "inherit" ? gallerySettings?.filter_images === "first_or_selected_image" ? "show_all_variants" : gallerySettings?.filter_images : thumbnailSettings?.thumbnail_filter_images,
        thumbnailMediaElements,
        state.selected_variant
      );
    }
    updateProductTitleAndDescription(product2, previousTitle);
    updateBreadcrumb(product2);
    rebuildFitFieldset(product2);
    rebuildBundleSummary(product2);
    syncSiblingFieldsets(product2.handle);
    updateYotpoWidgetsForProduct(product2);
    publishSiblingAnalytics(product2, state.selected_variant);
    // A sibling swap can change the info column's content height (e.g. the
    // bundle disclosure appearing/disappearing), but nothing else re-runs
    // the sticky maxHeight calculation afterward - it stays stale until the
    // next real scroll event, which can leave the sticky column's layout
    // briefly wrong immediately after a swap. Re-run it here, exactly like
    // the one-time call after initial page load above, so it reflects the
    // just-applied content.
    handleStickyScroll();
  }, "applySiblingProduct");
  const performSiblingSwap = /* @__PURE__ */ __name(async (handle, fieldsetEl) => {
    const targetUrl = utils.getSiblingUrl(handle);
    const productId = resolveSiblingProductId(handle, fieldsetEl);
    const mySwap = ++swapGeneration;
    let fetched = null;
    try {
      fetched = productId ? await _product.getHydratedSiblingData(handle, productId) : null;
    } catch (e) {
      fetched = null;
    }
    if (mySwap !== swapGeneration) return;
    const hasOnlyImageMedia = fetched ? (fetched.media ?? []).every((m) => !m.media_type || m.media_type === "image") : false;
    // A sibling relationship can point at a product rendered on a completely
    // different one-off template (confirmed live: one of Squid Inks' own
    // Color siblings, jeans-kinzies, renders on template "kinzies", not
    // product-bundle-new). Applying that product's data into THIS page's
    // shell would show it with the wrong layout/blocks, so this lightweight
    // path requires either an exact template match or both templates being
    // in the known-compatible family above - anything else correctly falls
    // back to a real navigation to its own template.
    const fetchedTemplate = fetched?.template_suffix ?? "";
    const currentTemplate = state.product.template_suffix ?? "";
    const sameTemplate = fetchedTemplate === currentTemplate || COMPATIBLE_TEMPLATE_FAMILY.has(fetchedTemplate) && COMPATIBLE_TEMPLATE_FAMILY.has(currentTemplate);
    // Bundle & Save only ever applies when the VIEWED product's own
    // template is literally product-bundle-new (a deliberate scope
    // decision, not inferred from metafield content - confirmed live that
    // a blank/Default product like Rusties can carry a populated, if
    // vestigial and self-only, smart_bundle_product metafield despite its
    // own template never rendering the block). Confirmed live: a page that
    // never rendered a Bundle & Save block at all (e.g. any Willys-style
    // Default product) has no DOM for rebuildBundleSummary() to reveal,
    // even when swapping to a genuine product-bundle-new sibling that has
    // real bundle-tier data (e.g. Mags). Constructing that whole
    // disclosure/summary/pack-card UI from scratch client-side was
    // considered and rejected as too much untested, guessed-at markup for
    // what it's worth - this falls back to a real navigation instead, same
    // safe mechanism used for cross-template siblings above.
    //
    // fetched.metafields.custom being undefined (as opposed to a present-
    // but-empty object) specifically means this data came from the DOM or
    // IndexedDB cache tier, not the network tier - e.g. Barba's own
    // site-wide link-prefetch (confirmed active independently of this
    // feature) caches a product from its main page-load render, which was
    // deliberately never extended with the custom namespace to avoid
    // bloating product cards site-wide (see _json.product.liquid). Only the
    // lightweight sibling-fetch's own network tier requests that namespace,
    // so it's always present (even as {}) whenever that tier actually ran.
    // Only worth resolving when the target is actually product-bundle-new -
    // ambiguous cached data for a non-bundle-new target changes nothing,
    // since rebuildBundleSummary hides regardless of its content there.
    const targetIsBundleTemplate = fetched?.template_suffix === "product-bundle-new";
    const bundleDataUnverified = fetched && targetIsBundleTemplate && fetched.metafields?.custom === void 0;
    const bundleDataMissingFromShell = !bundleFieldsetEl && targetIsBundleTemplate && (bundleDataUnverified || Array.isArray(fetched?.metafields?.custom?.smart_bundle_product) && fetched.metafields.custom.smart_bundle_product.length > 0);
    const bundleShellNeedsFreshData = !!bundleFieldsetEl && targetIsBundleTemplate && bundleDataUnverified;
    if (!fetched || !hasOnlyImageMedia || !fetched.variants?.length || !sameTemplate || bundleDataMissingFromShell || bundleShellNeedsFreshData) {
      barba.go(targetUrl);
      return;
    }
    try {
      applySiblingProduct(fetched);
    } catch (e) {
      barba.go(targetUrl);
      return;
    }
    barba.history.add(targetUrl, "barba", "push");
  }, "performSiblingSwap");
  const setSiblingProduct = /* @__PURE__ */ __name((handle, quickView2, fieldsetEl, forceFullNav) => {
    if (handle === state.product.handle) return;
    _product.lastOptions = {
      ..._product.lastOptions ?? {},
      ...state.product.options_with_values?.reduce((acc, option, index) => {
        acc[utils.handlelize(option?.name)] = state.options[index];
        return acc;
      }, {}) ?? {}
    };
    if (quickView2) {
      _stores.quickView.renderQuickView(handle);
      return;
    }
    if (forceFullNav) {
      barba.go(utils.getSiblingUrl(handle));
      return;
    }
    performSiblingSwap(handle, fieldsetEl);
  }, "setSiblingProduct");
  const setQuantity = /* @__PURE__ */ __name((quantity) => {
    state.quantity = quantity;
  }, "setQuantity");
  const handleStickyScroll = /* @__PURE__ */ __name(() => {
    [$refs.content, $refs.thumbnails, gallery].forEach((element) => {
      if (!element || !element.classList.contains("sticky-product-section")) return;
      if (state.scroll_column_element.getBoundingClientRect().bottom - 96 < element.scrollHeight - element.scrollTop) {
        element.style.maxHeight = "unset";
      } else {
        element.style.maxHeight = "";
      }
    });
  }, "handleStickyScroll");
  const scrollToMediaById = /* @__PURE__ */ __name(async (mediaId, no_variant_select = true) => {
    state.selected_media_id = mediaId;
    const image = gallery?.querySelector(`[data-media-id="${mediaId}"]`);
    if (thumbnailSettings?.select_variant_on_click && no_variant_select) {
      setSelectedVariant(
        state.product.variants.find((v) => v.featured_media?.id === mediaId)?.id || state.selected_variant?.id,
        false
      );
    }
    if (!image) return;
    await utils.delay(5);
    const header = document.querySelector(".header-sections-container");
    const offsetHeight = Math.max(0, header?.getBoundingClientRect()?.bottom ?? 0);
    const imageOffset = utils.getElementPosition(image);
    if (utils.isElementScrollable(scrollContainer)) {
      let scrollSnap = false;
      if (scrollContainer?.classList?.contains("snap-x")) {
        scrollContainer?.classList.remove("snap-x");
        scrollSnap = true;
      }
      utils.scrollToXY(
        200,
        image.offsetLeft,
        image.offsetTop,
        scrollContainer,
        () => {
          if (scrollSnap) {
            scrollContainer?.classList.add("snap-x");
          }
        }
      );
    } else {
      utils.scrollToXY(
        200,
        image.offsetLeft,
        imageOffset.top - offsetHeight - +getComputedStyle(gallery).paddingTop.replace("px", "")
      );
    }
  }, "scrollToMediaById");
  const renderComplementaryProducts = /* @__PURE__ */ __name((element, primary_source, secondary_source, product_class, limit) => {
    const fallback_products = utils.JSONParse(
      element.getAttribute("data-fallback-products")
    );
    const products = [];
    switch (primary_source) {
      case "complementary": {
        state.product?.complementary_products?.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "related": {
        state.product?.related_products?.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "manual": {
        fallback_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
    }
    switch (secondary_source) {
      case "complementary": {
        state.product?.complementary_products?.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "related": {
        state.product?.related_products?.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "manual": {
        break;
      }
    }
    state.show_complementary_products = products?.filter((prod) => prod.id !== state.product.id)?.filter((a, i, arr) => arr.findIndex((b) => b.id === a.id) === i)?.length > 0;
    const children = [...element.querySelectorAll("[data-product-handle]")];
    const renderProducts = products?.filter((prod) => prod.id !== state.product.id)?.filter((a, i, arr) => arr.findIndex((b) => b.id === a.id) === i)?.slice(0, limit) ?? [];
    if (!renderProducts?.filter(
      (prod, index) => prod.handle !== children?.[index]?.getAttribute("data-product-handle")
    )?.length) {
      return;
    }
    element.innerHTML = "";
    renderProducts.forEach((prod, i, arr) => {
      const node = document.querySelector(`[data-product-card='${product_class}']`)?.cloneNode(true);
      if (node) {
        node?.removeAttribute(`data-product-card`);
        node?.setAttribute("data-product-handle", prod.handle);
        node?.setAttribute("data-product-id", prod.id);
        node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
          el.remove();
        });
        element.appendChild(node);
        if (i + 1 < arr.length) {
          const div = document.createElement("div");
          div.setAttribute("data-style-divider", ``);
          element.appendChild(div);
        }
      }
    });
  }, "renderComplementaryProducts");
  const handleImageSelection = /* @__PURE__ */ __name((filter_setting, items, variant) => {
    switch (filter_setting) {
      case "show_all_variants": {
        items?.forEach(({ element, mediaId }) => {
          element.classList.toggle(
            "hidden",
            !state.product.variants.some((v) => v?.featured_media?.id === mediaId)
          );
        });
        return;
      }
      case "inherit":
        break;
      case "show_all": {
        items?.forEach(({ element, mediaId }) => element.classList.remove("hidden"));
        return;
      }
      case "selected_variant": {
        items?.forEach(({ element, mediaId }) => {
          element.classList.toggle("hidden", variant?.featured_media?.id !== mediaId);
        });
        return;
      }
      case "variant_images_by_order": {
        let hide = true;
        items?.forEach(({ element, mediaId }) => {
          if (variant.featured_media?.id === mediaId) {
            hide = false;
            element.classList.toggle("hidden", hide);
            return;
          }
          if (state.product.variants.map((v) => v?.featured_media?.id).includes(mediaId)) {
            hide = true;
          }
          element.classList.toggle("hidden", hide);
        });
        return;
      }
      case "variant_images_by_metafield": {
        items?.forEach(({ element, mediaId, metafield }) => {
          const show = variant?.featured_media?.id === mediaId || state.selected_variant?.metafields?.smart?.images?.some((m) => m.id === mediaId);
          element.classList.toggle("hidden", !show);
          element.classList.toggle("order-first", variant?.featured_media?.id === mediaId);
        });
        return;
      }
      case "variant_images_and_unassigned": {
        items?.forEach(({ element, mediaId }) => {
          const show = variant?.featured_media?.id === mediaId || !state.product.variants.map((v) => v?.featured_media?.id).includes(mediaId);
          element.classList.toggle("hidden", !show);
          element.classList.toggle("order-first", variant?.featured_media?.id === mediaId);
        });
        return;
      }
      case "only_unassigned": {
        items?.forEach(({ element, mediaId }) => {
          const show = !state.product.variants.map((v) => v?.featured_media?.id).includes(mediaId);
          element.classList.toggle("hidden", !show);
        });
        return;
      }
      case "first_or_selected_image": {
        items?.forEach(({ element, mediaId }) => {
          element.classList.toggle("hidden", state.selected_media_id !== mediaId);
        });
        return;
      }
    }
  }, "handleImageSelection");
  const openMediaGallery = /* @__PURE__ */ __name((mediaId) => {
    const mediaItems = mediaElements?.filter(
      (item) => (getComputedStyle(item.element)?.display !== "none" || getComputedStyle(
        thumbnailMediaElements?.find((img) => img.mediaId === item.mediaId)?.element
      )?.display !== "none") && item.media
    )?.filter((a, i, arr) => arr.findIndex((b) => b.mediaId === a.mediaId) === i)?.map((item) => item.media);
    const index = mediaItems.findIndex((item) => item.id === mediaId);
    _stores.mediaGallery.openGallery({
      media: mediaItems,
      index
    });
  }, "openMediaGallery");
  const truncateChildren = /* @__PURE__ */ __name((element, container, reCalculate = false) => {
    const children = [...container.children];
    if (children.at(-2)?.offsetLeft + children.at(-2)?.clientWidth < container.clientWidth) {
      return children.length - 1;
    }
    if (container.clientWidth === 0) {
      return container.children.length;
    }
    return children.findIndex(
      (childElement) => childElement.offsetLeft + childElement.clientWidth + element.clientWidth + +getComputedStyle(container).gap.replace("px", "") + 15 > container.clientWidth
    ) - 1;
  }, "truncateChildren");
  const hasAvailableVariant = /* @__PURE__ */ __name((index, value) => {
    return state?.product?.variants?.some((variant) => {
      if (variant.options[index] !== value || !variant.available) return false;
      return state?.options?.every(
        (selectedValue, i) => i === index || selectedValue == null || variant.options[i] === selectedValue
      ) ?? true;
    });
  }, "hasAvailableVariant");
  const hasIncompleteSelection = /* @__PURE__ */ __name(() => {
    return state.options?.some((option) => option == null) ?? false;
  }, "hasIncompleteSelection");
  const showConditionally = /* @__PURE__ */ __name((condition) => {
    switch (condition) {
      case "always": {
        return true;
      }
      case "with_subscriptions": {
        return !!state.selected_variant?.selling_plan_allocations?.length;
      }
      case "no_subscriptions": {
        return !state.selected_variant?.selling_plan_allocations?.length;
      }
    }
  }, "showConditionally");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const labels = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return acc || "";
      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);
    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  }, "getContentLabels");
  const getDiscountLabel = /* @__PURE__ */ __name((type) => {
    const price = state.selected_variant?.price ?? 0;
    const compare_at_price = state.selected_variant?.compare_at_price ?? 0;
    if (compare_at_price <= price) {
      return "";
    }
    switch (type) {
      case "sale": {
        return "Final Sale";
      }
      case "percentage": {
        return `${Math.round((compare_at_price - price) * 100 / compare_at_price)}% off`;
      }
      case "value": {
        return `Save ${utils.formatMoney(
          compare_at_price - price,
          window?.money_format?.replace(/\{(\s*)amount(\s*)}/gi, "{$1amount_no_decimals$2}")
        )}`;
      }
      default: {
        return "";
      }
    }
  }, "getDiscountLabel");
  const renderDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.renderBracketInputDynamicText(content, state);
  }, "renderDynamicText");
  _product.getHydratedProductData(product.handle, product.id).then((res) => {
    state.product = state.product.handle === res.handle ? res : state.product;
    state.selected_variant = state.product?.variants?.find((variant) => variant.id === state.selected_variant?.id) ?? state.selected_variant;
  });
  handleStickyScroll();
  window.Alpine.effect(() => {
    state.isPrimary = /^product\.?/gi.test(_stores.router.template) && $el?.closest("[data-content-root]")?.querySelector(`[data-section-type="product"]`) === $el;
    if (state?.isPrimary && !window.design_mode) {
      window.onpopstate = handlePopState;
      const url = new URL(window.location.href);
      const selling_plan_id = +url.searchParams.get("selling_plan") || void 0;
      const variant_id = +url.searchParams.get("variant") || void 0;
      const remove = [];
      if (!state.selected_variant?.id) {
        remove.push("variant");
      }
      if (!state.selected_selling_plan?.id) {
        remove.push("selling_plan");
      }
      if (window?.event?.type === "popstate") {
        return;
      }
      if (init || window?.event?.barba_redirect) {
        if (product?.handle !== state?.product?.handle) {
          state.product = product;
        }
        if (variant_id !== state.selected_variant?.id) {
          state.selected_variant = product?.variants?.find((v) => v.id === (variant_id ?? product.selected_variant_id));
          state.selected_media_id = product?.media?.[0]?.id;
          state.properties = {};
          state.selling_plan_allocations = selling_plan_allocations;
          state.selected_price = discounted_price;
          state.selected_compare_at_price = Math.max(
            state.selected_variant?.compare_at_price ?? first_available_variant?.compare_at_price ?? product?.compare_at_price_min ?? discounted_price ?? 0,
            state.selected_variant?.price ?? first_available_variant?.price ?? discounted_price ?? 0
          );
          state.dynamic_buy_button = null;
          state.options = state.selected_variant?.options ?? new Array(product?.options_with_values?.length || 0).fill(null);
        }
        if (selling_plan_id !== state.selected_selling_plan?.id) {
          state.selected_selling_plan = state.selected_variant.selling_plan_allocations?.find(
            (plan) => plan.selling_plan_id === selling_plan_id
          )?.selling_plan;
        }
        return;
      }
      if (selling_plan_id !== state.selected_selling_plan?.id || variant_id !== state.selected_variant?.id) {
        url.searchParams.set("selling_plan", `${state.selected_selling_plan?.id}`);
        url.searchParams.set("variant", `${state.selected_variant?.id}`);
        remove.forEach((key) => {
          url.searchParams.delete(key);
        });
        barba.history.add(url.toString(), "barba", !variant_id ? "replace" : "replace");
      }
    }
  });
  window.Alpine.effect(() => {
    if (state.dynamic_buy_button) {
      state.dynamic_buy_button.disabled = !state.selected_variant?.available;
      if (!state.dynamic_buy_button?.hasAttribute("data-no-out-of-stock")) {
        state.dynamic_buy_button.classList.toggle(
          "dynamic-buy-button-out-of-stock",
          !state.selected_variant?.available
        );
      }
    }
  });
  window.Alpine.effect(() => {
    if (quickView) {
      $refs?.thumbnails?.classList.add("!hidden");
      columnElements?.forEach((el) => {
        el.classList.remove("sticky-product-section");
        el.classList.add("quick-view-product-section", "!py-0");
        el.style.maxHeight = "";
      });
      $el.querySelectorAll("[data-block-type='breadcrumbs']").forEach((element) => {
        element.style.display = "none";
      });
      $refs.content.classList.add("!max-w-unset", "lg:!min-w-[45%]", "lg:h-full");
      scrollContainer.classList.remove(
        "product-gallery--grid",
        "product-gallery--hero-grid",
        "product-gallery--column"
      );
      scrollContainer.classList.add("max-lg:[&_picture]:w-[unset]", "max-lg:[&_picture]:h-[280px]");
      $refs.container.classList.add("lg:!p-0", "!py-0");
      gallery.classList.add("!max-h-full", "!h-full", "flex", "flex-col");
      Shopify?.PaymentButton?.init();
      handleImageSelection(gallerySettings?.filter_images, mediaElements, state.selected_variant);
      if (thumbnailSettings) {
        handleImageSelection(
          thumbnailSettings?.thumbnail_filter_images === "inherit" ? gallerySettings?.filter_images === "first_or_selected_image" ? "show_all_variants" : gallerySettings?.filter_images : thumbnailSettings?.thumbnail_filter_images,
          thumbnailMediaElements,
          state.selected_variant
        );
      }
      return;
    }
    handleImageSelection(gallerySettings?.filter_images, mediaElements, state.selected_variant);
    if (thumbnailSettings) {
      handleImageSelection(
        thumbnailSettings?.thumbnail_filter_images === "inherit" ? gallerySettings?.filter_images === "first_or_selected_image" ? "show_all_variants" : gallerySettings?.filter_images : thumbnailSettings?.thumbnail_filter_images,
        thumbnailMediaElements,
        state.selected_variant
      );
    }
    columnElements.forEach((element) => {
      element.classList.add("sticky-product-section");
      element.classList.remove("relative");
    });
    state.scroll_column_element = columnElements?.reduce(
      (acc, element) => acc?.scrollHeight > element?.scrollHeight ? acc : element,
      null
    );
    state.scroll_column_element?.classList?.remove("sticky-product-section");
    state.scroll_column_element?.classList?.add("relative");
  });
  window.Alpine.effect(() => {
    // This effect's own product must be read from state.product, not the
    // outer closure `product` - sibling/bundle-tier navigation (barba.go
    // via setSiblingProduct) updates state.product on this same Alpine
    // instance without re-running initProduct, so the closure `product`
    // is stale (still the page-load product) by the time this reruns.
    // Reading state.product here is what makes this effect track the
    // change at all, and first_available_variant below sidesteps
    // price_min/price being corrupted to 0 by unavailable variants that
    // were never priced (e.g. Versatility 3-Pack) - see the matching
    // comment above `first_available_variant`.
    const current_product = state.product;
    const current_fallback_variant = current_product?.variants?.find(
      (v) => v.id === current_product?.selected_or_first_available_variant_id
    );
    let discounted_price2 = state.selected_variant?.price ?? current_fallback_variant?.price ?? current_product?.price_min ?? current_product?.price;
    const price_adjustment2 = state.selected_selling_plan?.price_adjustments?.[0];
    if (price_adjustment2?.value_type === "fixed_amount") {
      discounted_price2 = Math.max(discounted_price2 - Math.round(+price_adjustment2?.value), 0);
    }
    if (price_adjustment2?.value_type === "percentage") {
      discounted_price2 = Math.max(
        discounted_price2 - Math.round(+price_adjustment2?.value / 100 * discounted_price2),
        0
      );
    }
    state.selected_price = discounted_price2;
    state.selected_compare_at_price = Math.max(
      state.selected_variant?.compare_at_price ?? current_fallback_variant?.compare_at_price ?? current_product?.compare_at_price_min ?? discounted_price2 ?? 0,
      state.selected_variant?.price ?? current_fallback_variant?.price ?? discounted_price2 ?? 0
    );
  });
  if (state.isPrimary) {
    window.Alpine.store("main_product", {
      state,
      card,
      bundle,
      settings,
      showConditionally,
      handleAddToCart,
      handleBackInStockNotification,
      handleBackInStockHelperClick,
      styleDynamicBuyButton,
      setSelectedVariant,
      toggleSelectedVariant,
      setProductOption,
      toggleProductOption,
      setSiblingProduct,
      setSellingPlan,
      setQuantity,
      handleStickyScroll,
      scrollToMediaById,
      openMediaGallery,
      truncateChildren,
      renderComplementaryProducts,
      hasAvailableVariant,
      hasIncompleteSelection,
      getContentLabels,
      getDiscountLabel,
      renderDynamicText
    });
    const main_product = window.Alpine.store("main_product");
    window.Alpine.magic("main_product", () => main_product);
    window._stores["main_product"] = main_product;
  }
  init = false;
  return {
    state,
    card,
    bundle,
    settings,
    showConditionally,
    handleAddToCart,
    handleBackInStockNotification,
    handleBackInStockHelperClick,
    styleDynamicBuyButton,
    setSelectedVariant,
    toggleSelectedVariant,
    setProductOption,
    toggleProductOption,
    setSiblingProduct,
    setSellingPlan,
    setQuantity,
    handleStickyScroll,
    scrollToMediaById,
    openMediaGallery,
    truncateChildren,
    renderComplementaryProducts,
    hasAvailableVariant,
    hasIncompleteSelection,
    getContentLabels,
    getDiscountLabel,
    renderDynamicText
  };
}, "initProduct");
window._sections["initProduct"] = initProduct;
